var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var gql = String.raw;
export var IndicatorResultsFields = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  id value slug numericValue year __typename _schema { label pluralLabel }\n  description { id text }\n  color { value }\n  links { id url name slug __typename }\n  indicator { id }\n"], ["\n  id value slug numericValue year __typename _schema { label pluralLabel }\n  description { id text }\n  color { value }\n  links { id url name slug __typename }\n  indicator { id }\n"])));
var templateObject_1;